import createActionType from "../utils/createActionType";

export const MODULE = "sales-order";

export const SET_QUERY_KEY = createActionType(MODULE, "setQueryKey");

export const SET_IS_FETCHING_COMPANY_SCHEMAS_STATUS = createActionType(
  MODULE,
  "setIsFetchingCompanySchemasStatus"
);

export const SET_IS_FETCHING_CUSTOM_SCHEMAS_STATUS = createActionType(
  MODULE,
  "setIsFetchingCustomSchemasStatus"
);

export const SET_IS_SAVING_COMPANY_SCHEMAS_STATUS = createActionType(
  MODULE,
  "setIsSavingCompanySchemasStatus"
);

export const SET_COMPANY_SCHEMAS = createActionType(MODULE, "setCompanySchemas");

export const SET_DEFAULT_COMPANY_SCHEMAS = createActionType(MODULE, "setDefaultCompanySchemas");

export const SET_CUSTOM_SCHEMAS = createActionType(MODULE, "setCustomSchemas");

export const SET_SELECTED_ROWS = createActionType(MODULE, "setSelectedRows");

export const SET_PAGINATION = createActionType(MODULE, "setPagination");

export const SET_IS_DUPLICATING_ORDER_STATUS = createActionType(
  MODULE,
  "setIsDuplicatingOrderStatus"
);

export const SET_IS_DUPLICATE_ORDER_ALERT_VISIBLE = createActionType(
  MODULE,
  "setIsDuplicateOrderAlertVisible"
);

export const SET_ACTIVE_ORDER = createActionType(MODULE, "setActiveOrder");

export const SET_ACTIVE_COLUMN = createActionType(MODULE, "setActiveColumn");

export const SET_IS_EXPORTING_MODAL_VISIBLE = createActionType(
  MODULE,
  "setIsExportingModalVisible"
);

export const SET_IS_DELETING_COLUMN_STATUS = createActionType(MODULE, "setIsDeletingColumnStatus");

export const SET_IS_DELETE_CUSTOM_COLUMN_MODAL_VISIBLE = createActionType(
  MODULE,
  "setIsDeleteCustomColumnModalVisible"
);

export const RESET = createActionType(MODULE, "reset");
